import {css} from 'lit'; export default css`:host{-webkit-app-region:drag;display:block}`;
    